import { cloneDeep } from 'lodash';

const handleAssignees = (state, payload) => {
  const { placeId, pointId, events } = payload;
  if (!placeId || !pointId || !events?.orders || !events?.calls) {
    console.error('Malformed request');
    return state;
  }

  const newState = cloneDeep(state);

  for (const eventId in events.orders) {
    if (newState.activeEvents[eventId]) {
      newState.activeEvents[eventId].assignee = events.orders[eventId];
    }
  }

  for (const eventId in events.calls) {
    if (Array.isArray(newState.calls?.[pointId])) {
      for (const call of newState.calls?.[pointId]) {
        if (call.id === eventId) {
          call.assignee = events.calls[eventId];
        }
      }
    }
  }
  
  return newState;
};

export { handleAssignees };
